import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const getRequest = async (
  id: string | undefined,
  source: Crud<IRequest>
): Promise<IRequest> => {
  changeRequestSourceFilterGlobal(source, id)

  // todo: get rid of {} as IRequest, return IRequest | null
  const emptyObject = {} as IRequest
  if (id) {
    const request = await source.getById({ id, keyField: 'EntryId' })
    return request || emptyObject
  }
  return emptyObject
}

/**
 * This is filter change because of global Crud source usage
 * @param requestId
 * @param source
 */
function changeRequestSourceFilterGlobal(source: Crud<IRequest>, requestId?: string) {
  source.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'EntryId',
        operator: Operator.EQUAL,
        value: requestId || null,
      },
    ],
  })
}
